import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { ymHit } from '../services/ya-metrika/ya-metrika';

export interface IYandexMetrikaParams {
  counterId: number;
  pathname:string;
}

export function useYandexMetrika(counterId: number): IYandexMetrikaParams {
  const location = useLocation();

  useEffect((): void => {
    if (!Number.isFinite(counterId)) return;

    ymHit(counterId, location.pathname);
  }, [location, counterId]);

  return { counterId, pathname: location.pathname };
}